import { useState } from 'react';

import './sales-panels.scss';

import { useMenuCategories } from '../../../../api/hooks/menu-categories/useMenuCategories';
import { usePromotionEntityQuery, usePromotionRedemptions } from '../../../../api/hooks/sales/usePromotionEntityQuery';
import { getPromotionColumnDefinition, PROMOTION_TABS } from '../../../../schema/sales/promotion.schema';
import { EntityTable } from '../../../common/entity-table/EntityTable';
import { Modal } from '../../../common/modal/Modal';

const RedemptionLog = ({ promotionId }) => {
  const { redemptions, isLoading } = usePromotionRedemptions(promotionId);

  if (isLoading) return <div className="sales-panel__loading">Loading...</div>;

  return (
    <div className="sales-panel__table-wrap">
      <table className="sales-table">
        <thead>
          <tr>
            <th>Order</th>
            <th>Customer</th>
            <th>Discount Applied</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {redemptions.length === 0 && (
            <tr>
              <td colSpan={4} className="sales-table__empty">
                No redemptions yet
              </td>
            </tr>
          )}
          {redemptions.map((r) => (
            <tr key={r.id}>
              <td>{r.orderNumber}</td>
              <td>{r.customerEmail ?? r.customerId ?? '-'}</td>
              <td>R{parseFloat(r.discountApplied).toFixed(2)}</td>
              <td>{new Date(r.redeemedAt).toLocaleDateString('en-ZA')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const PromotionsPanel = () => {
  const promotionQuery = usePromotionEntityQuery();
  const { data: categories } = useMenuCategories();
  const [logPromotion, setLogPromotion] = useState(null);

  const wrappedColumnDef = (onEdit, onView, onDelete) =>
    getPromotionColumnDefinition(onEdit, onView, onDelete, setLogPromotion);

  return (
    <>
      <EntityTable
        query={promotionQuery}
        getColumnDefinition={wrappedColumnDef}
        entityTabs={PROMOTION_TABS(categories)}
        entityName="Promotion"
        canView={false}
      />

      <Modal
        title={logPromotion ? `${logPromotion.description || 'Promotion'}: Redemption Log` : ''}
        isOpen={!!logPromotion}
        onClose={() => setLogPromotion(null)}
        width={680}
        minHeight="460px"
      >
        {logPromotion && <RedemptionLog promotionId={logPromotion.id} />}
      </Modal>
    </>
  );
};
